const VISIBLE_CLASS = 'is-visible';
const BUY_BOX_ID = 'product-picker-form';
const BUY_BOX_FALLBACK_SELECTOR = '[data-picker-form]';
const STICKY_CTA_BUTTON_SELECTOR = '[data-sticky-cta-button]';

class PdpStickyCta extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.buyBox = null;
    this.observer = null;
    this.onClick = this.onClick.bind(this);
    this.onIntersect = this.onIntersect.bind(this);
  }

  connectedCallback() {
    if (!window.stickyCtaEnabled) return;

    this.button = this.querySelector(STICKY_CTA_BUTTON_SELECTOR);
    if (!this.button) return;

    this.buyBox = document.getElementById(BUY_BOX_ID) || document.querySelector(BUY_BOX_FALLBACK_SELECTOR);
    if (!this.buyBox) return;

    this.hidden = false;

    this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0 });
    this.observer.observe(this.buyBox);

    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.observer = null;
    this.button?.removeEventListener('click', this.onClick);
  }

  onIntersect(entries) {
    const entry = entries[0];
    if (!entry) return;


    const scrolledPastBuyBox = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    this.classList.toggle(VISIBLE_CLASS, scrolledPastBuyBox);
  }

  onClick() {
    this.buyBox?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('pdp-sticky-cta')) {
  customElements.define('pdp-sticky-cta', PdpStickyCta);
}
